var _rect, _circle, _path, _circle2, _circle3, _rect2, _path2, _circle4, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundNotComplies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 86,
    height: 86,
    rx: 4.5,
    fill: "white",
    stroke: "#c55757"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1648,
    cy: 39.8073,
    r: 26.6745,
    fill: "#c55757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2636 47.1934C26.2636 59.2056 49.3559 61.5566 37.3438 61.5566C25.3316 61.5566 15.5938 51.8188 15.5938 39.8066C15.5938 27.7944 25.3316 18.0566 37.3438 18.0566C49.3559 18.0566 26.2636 27.4953 26.2636 47.1934Z",
    fill: "#c47474"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.9332,
    cy: 40.2174,
    r: 6.56604,
    fill: "#c47474"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.9339,
    cy: 40.218,
    r: 4.10377,
    fill: "#c55757"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0566,
    y: 68.124,
    width: 41.0377,
    height: 5.74528,
    rx: 2,
    fill: "#c55757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6309 71.4066C59.2299 71.133 67.3007 69.5188 68.9422 65.2509C70.5837 60.983 70.7205 53.8971 70.5837 50.8877",
    stroke: "#c55757",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5847,
    cy: 50.0661,
    r: 4.92453,
    fill: "#c55757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.922 52.3649C72.7805 54.0554 70.4847 54.5004 68.7943 53.3589C67.1038 52.2174 69.8301 52.5583 70.9716 50.8678C72.1132 49.1773 71.2375 46.0956 72.928 47.2371C74.6185 48.3786 75.0636 50.6744 73.922 52.3649Z",
    fill: "#c55757"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.697 48.0077C68.5207 46.8862 70.0782 46.6079 70.7313 47.0888C71.1118 47.369 70.4914 47.9862 69.6677 49.1077C68.8441 50.2292 68.3131 51.0081 67.932 50.7282C67.3714 50.3164 66.8733 49.1292 67.697 48.0077Z",
    fill: "#c47474"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundNotComplies);
export default __webpack_public_path__ + "static/media/round-not-complies.8b6f257529249f81c19031aead62fcf9.svg";
export { ForwardRef as ReactComponent };